import { HYDRATE_EXPERTS, RESET_NUM_CHAT_ACTIVE_ASSIGNED_FOR_EXPERT, UPDATE_EXPERT } from 'actions/types';
import dotProp from 'dot-prop-immutable';
import keyBy from 'lodash/keyBy';
import { expertsInitialState } from 'initialStaticState';

export const updateExpertLens = (expertsState, simplrExpertId, attributes) => ({
  ...expertsState,
  idsToExperts: {
    ...expertsState.idsToExperts,
    [simplrExpertId]: {
      ...(expertsState.idsToExperts[simplrExpertId] || {}),
      ...attributes,
    },
  },
});

export const experts = (state = expertsInitialState, action) => {
  switch (action.type) {
    case RESET_NUM_CHAT_ACTIVE_ASSIGNED_FOR_EXPERT:
      return dotProp.set(state, `experts[${action.simplrExpertId}].numChatActiveAssigned`, 0);

    case HYDRATE_EXPERTS:
      const idsToExperts = keyBy(action.experts, (expert) => expert.id);

      return {
        ...state,
        idsToExperts,
      };

    case UPDATE_EXPERT:
      return updateExpertLens(state, action.expert.id, action.expert);

    default:
      return state;
  }
};

export default experts;
